import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import { Content } from '@/components/Rankings/style.css'
import { Columns } from '@/components/Article/style.css'
import Summary from '@/components/Summary'
import data from '@/components/Feature/Rankings/Data'
import Ranking from '@/components/Feature/Rankings/Ranking'
import TitleSelector from '@/components/Feature/Rankings/TitleSelector'
import { CalidadDeLaGestion } from '@/components/Feature/Rankings/Output'

const IndexPage = () => {
  const rankings = data.filter(item => item.name === 'Rankings')[0].rankings
  const datalocal = rankings.find(
    item =>
      item.link === '/rankings-generales/percepcion-de-calidad-de-la-gestion/',
  )

  return (
    <Layout>
      <SEO
        title={datalocal.name}
        keywords={[
          `La Tercera`,
          `${datalocal.name}`,
          `Ranking de Universidades Chilenas 2021`,
        ]}
      />
      <Content>
        <TitleSelector
          pretitle="Ranking de Universidades 2021"
          allRankings={rankings}
          section="rankings-generales"
          sectionSlug={datalocal.slug}
        />
        <Columns>
          <p>
            Si bien no es el único factor que determina este ranking, los años
            de acreditación institucional sigue siendo el indicador que más
            pesa, pues entre el mínimo y el máximo de años —3 y 7 años—, la
            diferencia es sideral. En febrero, la U. de Santiago ingresó al
            exclusivo club de las universidades que cuentan con siete años de
            acreditación y que hasta ahora solo ostentaban la Católica, de Chile
            y de Concepción.
          </p>

          <p>
            A estos planteles de excelencia, se suman otras ocho casas de
            estudio que tienen 6 años: de La Frontera, de Talca, Austral, Santa
            María, Católica del Norte, Católica de Valparaíso, Adolfo Ibáñez y
            del Desarrollo.
          </p>

          <p>
            Estas últimas dos, son las primeras universidades privadas que
            despegan de los cinco años.
          </p>

          <p>
            Contraria es la realidad de las universidades UNIACC, de Viña del
            Mar, Metropolitana de Ciencias de la Educación y SEK que tienen tres
            años, lo que indica la nueva Ley de Educación Superior, que dichas
            instituciones tienen un nivel básico. Mientras que hay otros cinco
            planteles —los que no sonmedidos en este ranking, precisamente
            porque no están acreditados—, que por ley tienen hasta enero de 2025
            para lograrlo. Estas son la U. Gabriela Mistral, U. de Aconcagua, U.
            del Alba, ex Pedro de Valdivia, U. Miguel de Cervantes y U.
            Bolivariana, las que de no conseguirlo, pasan a ser supervisadas por
            del Consejo Nacional de Educación (CNED), institución que acompaña
            el proceso durante tres años, solo tras ello, la Subsecretaría de
            Educación puede solicitar un proceso de cierre.
          </p>

          <p>
            Distinto es el caso de la U. La República y la U. de Los Leones,
            instituciones que no pueden recibir alumnos en 2021, ya que mientras
            la primera tiene un cierre decretado, la segunda está en un proceso
            de reestructuración. Por otra parte, las dos universidades estatales
            que fueron fundadas en 2015, U. de Aysén y U. de O´Higgins, están
            eximidas de la acreditación por un plazo de cinco años, pero ya
            iniciaron el proceso, durante este tiempo han tenido un modelo de
            acompañamiento de la U. de Chile, el que no es vinculante, ya que es
            un apoyo.
          </p>
        </Columns>
        <CalidadDeLaGestion />
        <Columns>
          <h3>Alumnos por JCE</h3>

          <p>
            El número de alumnos por Jornada Completa Equivalente es el segundo
            indicador considerado, se trata de una medida que permite
            estandarizar la carga académica de los profesores. Si se analiza el
            número de JCE con la matrícula 2021, en el sistema universitario la
            relación es de 23,4 estudiantes por JCE. Sobre ese promedio se
            encuentran las universidades Santa María (30,2), San Sebastián
            (29,8), Arturo Prat (28,7), de Tarapacá (28,7), Central (28,5),
            Alberto Hurtado (27,9), Academia de Humanismo Cristiano (27,7),
            Católica de Valparaíso (27,6), de La Serena (26,5), Autónoma (25,3),
            del Bío-Bío (25,1), Diego Portales (24,6), Tecnológica Metropolitana
            (24,5), de Viña del Mar (24,4), Católica de la Santísima Concepción
            (23,7), Andrés Bello (23,7) y de La Frontera (23,5).
          </p>

          <p>
            Mientras que los planteles que presentan el menor número de JCE por
            alumnos son del Desarrollo (14,3), de Magallanes (14,5),
            Metropolitana de Ciencias de la Educación (15,2), Católica (16,0) y
            de Chile (17,8).
          </p>

          <h3>Retención</h3>

          <p>
            De acuerdo a la información que registra de mifuturo.cl, las tres
            primeras universidades que más retienen a sus alumnos son la de Los
            Andes, Adolfo Ibáñez y Católica, más del 80% de sus estudiantes
            continúan al tercer año. Además, el abandono estudiantil difiere
            entre las instituciones y según las áreas y carreras. En las
            universidades del Consejo de Rectores el rango de deserción a los
            dos años varía entre el 65% y 85%, lo que influye en el costo final
            de la matrícula. Quienes se encuentran en el rango inferior son las
            universidades de Atacama, de La Serena y de Magallanes.
          </p>

          <p>
            Según los expertos, la deserción en pregrado está asociada a
            pérdidas de eficiencia. Las universidades se ven directamente
            afectadas pues dejan de percibir los recursos asociados a los
            estudiantes que desertan, lo que implica que deben adoptar su
            funcionamiento en cursos mayores que cuentan con menos alumnos. Por
            su parte, los jóvenes que dejan de lado sus estudios ven truncada la
            posibilidad de graduarse, lo que genera frustración y descontento.
          </p>

          <p>
            En cuanto a los motivos, los principales se relacionan con
            dificultades de orientación vocacional y con un rendimiento
            académico insuficiente.
          </p>

          <p>
            El último estudio del SIES sobre la Retención 1er en 2021, señala
            que aquellos estudiantes que tienen beneficios (becas, gratuidad y/o
            créditos) tienen un menor nivel de deserción: 80,5% continua sus
            estudios, mientras que baja a un 66,3% para los estudiantes sin
            beneficios —una diferencia de 14 p.p.—.
          </p>

          <p>
            Por otra parte, la tasa de Persistencia de 1er año, que mide la
            presencia de estudiantes de la cohorte 2020 en la matrícula 2021 en
            la misma o en otra institución de Educación Superior, con
            independencia de si se mantiene en la cohorte de origen, es de 93,9%
            en estudiantes universitarios que cuentan con algún tipo de
            beneficio estudiantil y de 86,3% para estudiantes sin beneficios
            (7,6 p.p. en favor de los primeros).
          </p>
        </Columns>
        <Columns>
          <h3>Sobreduración de las carreras </h3>

          <p>
            Según los datos, la U. de La Frontera, U. del Desarrollo, Católica y
            de Valparaíso lideran el ranking, con menos de tres semestres de
            diferencia. En la parte inferior de la tabla, se encuentran la Santa
            María y Católica del Norte, con cerca de 5 semestres promedio.
          </p>

          <h3>¿Qué es lo que mide este indicador?</h3>

          <p>
            Las instituciones definen una duración formal —entendida como la
            duración esperada de una carrera, considerando el número de
            semestres del plan de estudios y del proceso de titulación— para sus
            diferentes programas. Por lo general, se expresa en semestres, se
            establece el tiempo que se dedicará a las clases teóricas y
            prácticas, así como también a la titulación. En general, los
            estudiantes tardan más en titularse que lo establecido formalmente.
          </p>

          <p>
            Para tener una muestra objetiva de lo que demora un alumno en
            estudiar una carrera comparado con el promedio de duración de ésta,
            debe distinguirse con precisión los conceptos involucrados: duración
            formal de carreras, duración real de carreras y titulación oportuna.
          </p>

          <p>
            En este sentido, el problema de tener un alto índice de atraso en la
            concreción de las carreras universitarias tiene que ver con el
            diseño y la estructura curricular —las exigencias de algunos
            planteles para otorgar títulos es mayor que en otros—, pero también
            involucra a los alumnos puesto que el perfil de éstos, las
            competencias por falencias formativas de etapas anteriores y el poco
            nivel de endeudamiento estudiantil influyen en lo que demore un
            joven en finalizar sus estudios.
          </p>

          <p>
            Hay que tener presente que el año 2020, las carreras con mayor
            duración real promedio en las universidades fueron Ingeniería Civil
            Electrónica (16,7 semestres), Derecho (16,6), Ingeniería Civil
            Mecánica (16,5) e Ingeniería Civil (16,3), lo que claramente afecta
            a los planteles que dictan estas licenciaturas.
          </p>

          <h3>Alzas y retrocesos</h3>

          <p>
            Año a año, hemos constatado como hay indicadores que determinan el
            cambio en las posiciones de las casas de estudio, uno de ellos son
            los años de acreditación. Dado lo anterior, los mayores saltos de
            este año se produjeron en tres instituciones que aumentaron en un
            año esta certificación: la U. de Los Lagos, pasó de 4 a 5 años, lo
            que le reportó subir 14 puestos —del 31 al 17—, mientras que la U.
            Adolfo Ibáñez saltó del 14 al 7, gracias a sus 6 años. Mientras que
            los 7 años de la U. de Santiago le permitieron subir cinco puestos,
            quedando en la 3ra posición, mientas que los 6 años de la U. del
            Desarrollo, la posicionaron en el cuarto lugar del ranking.
          </p>

          <p>
            Pero no es el único indicador determinante. La pandemia trajo
            consigo, a nivel general, ajustes en los cuerpos docentes, por lo
            que en varias casas de estudio los estudiantes por JCE aumentaron de
            manea ostensible con respecto a los últimos años. Uno de ellos es el
            caso de la U. San Sebastián, la que tuvo un descenso pronunciado,
            debido, principalmente, a que aumento su matrícula en poco más de
            2.500 estudiantes —de 32.365 en 2020 a 34.905 en 2021—, mientras que
            en este mismo período sus JCE descendieron en 600 —de 1.926 a
            1.282—. Estos cambios se tradujeron en pasar de 18,3 estudiantes/JCE
            (bajo la media del sistema universitario) a 29,8 estudiantes/JCE,
            solo por debajo de la Santa María. La misma situación sucede con la
            U. Academia de Humanismo Cristiano, el año pasado contaba con 20,3
            estudiantes/JCE y este año registra 27,74. Este plantel también
            aumentó su matrícula (330 alumnos más) y disminuyó las JCE (40
            menos).
          </p>
        </Columns>
        <Summary />
      </Content>
    </Layout>
  )
}

export default IndexPage
